import { initializeApp, getApps } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging, isSupported } from 'firebase/messaging';

// --- Helper Functions and Configuration ---
const firebaseConfig = {
  apiKey: "AIzaSyAmlFhHsPlyzSllcRWMimZ1BxBKfaBhbrI",
  authDomain: "exam-platform-v2.firebaseapp.com",
  databaseURL: "https://exam-platform-v2-default-rtdb.firebaseio.com",
  projectId: "exam-platform-v2",
  storageBucket: "exam-platform-v2.firebasestorage.app",
  messagingSenderId: "745181277731",
  appId: "1:745181277731:web:09fb82a206704f06ba4b96",
  measurementId: "G-ENPB4XDQM3"
};   

let app;
if (!getApps().length) {
    try {
      app = initializeApp(firebaseConfig);
    } catch (e) {
      console.error("Firebase initialization error:", e);
    }
} else {
    app = getApps()[0];
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);
export const functions = getFunctions(app, 'us-central1');

// NEW: Initialize and export Messaging
// Using typeof window !== 'undefined' prevents errors if you ever implement Server-Side Rendering
export const messagingReady = typeof window !== 'undefined'
    ? isSupported().then(supported => supported ? getMessaging(app) : null).catch(() => null)
    : Promise.resolve(null);

export default app;
export { firebaseConfig };